// TODO: Import React module
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

// TODO: Import MUI module
import { Button, } from '@mui/material';

// TODO: Import MUI icon
import { Work } from '@mui/icons-material';

// TODO: Import context
import { Context, fetchData } from '../Common/Context';
import { Text } from '../Common/Text';

// TODO: Import custom component

const ButtonRecruit = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component ButtonRecruit Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable
    const [info, setInfo] = React.useState([]);

    // TODO: Define event
    const navigate = useNavigate();

    React.useEffect(() => {
        const formData = new FormData();
        formData.append('action', 'Recruit_GetInfo');
        fetchData(formData, (result) => { setInfo(result) });
    }, []);

    const handleButtonClick = () => navigate('/Recruit');

    // TODO: Define function

    // TODO: Return component
    return (
        <>
            {info.length > 0 &&
                <Button onClick={handleButtonClick} variant="contained" startIcon={<Work />}>
                    {Text.Recruit.Title[context.language]}
                </Button>}
        </>
    );
}
export default ButtonRecruit;